import React from "react";
import { Modal, Box, Button } from "@mui/material";

const modalStyle = {
  backgroundColor: "#fff",
  padding: "24px",
  borderRadius: "8px",
  width: "90%",
  maxWidth: "400px",
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  textAlign: "center",
};

const overlayStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1300,
};

//called from App.jsx
const LoginAgain = ({
  showLoginModal,
  setShowLoginModal,
  header = "Session Expired",
  subHeader = "Your session has expired. Please log in again to continue.",
  hideLoginBtn=false,
}) => {
  const handleLogin = () => {
    setShowLoginModal(false);
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login";
  };

  return (
    <Modal
      open={showLoginModal}
      onClose={() => hideLoginBtn && setShowLoginModal(false)}
      style={overlayStyle}
    >
      <div style={modalStyle}>
        <h2>{header}</h2>
        <p>{subHeader}</p>
        {!hideLoginBtn && <Button variant="contained" color="primary" onClick={handleLogin}>
          Login Again
        </Button>}
      </div>
    </Modal>
  );
};

export default LoginAgain;
